export enum UserGroupsTranslationKey {
    ADD_GROUP = "userGroups.addGroup",
    ADD_MEMBER = "userGroups.addMember",
    ADD_MEMBERSHIP = "userGroups.addMembership",
    ADD_PERMISSION = "userGroups.addPermission",
    DELETE_GROUP = "userGroups.deleteGroup",
    DELETE_PERMISSION = "userGroups.deletePermission",
    DELETE_PERMISSION_QUESTION_MARK = "userGroups.deletePermissionQuestionMark",
    DELETE_USER_GROUP_QUESTION_MARK = "userGroups.deleteUserGroupQuestionMark",
    DESCRIPTION = "userGroups.description",
    DETAILS = "userGroups.details",
    EDIT_PERMISSION = "userGroups.editPermission",
    EDIT_USER_GROUP = "userGroups.editUserGroup",
    EMAIL = "userGroups.email",
    FIRST_NAME = "userGroups.firstName",
    GROUP_DETAIL = "userGroups.groupDetail",
    LAST_NAME = "userGroups.lastName",
    LOGIN = "userGroups.login",
    MEMBERS = "userGroups.members",
    MEMBERSHIP_WILL_BE_REMOVED = "userGroups.membershipWillBeRemoved",
    NAME = "userGroups.name",
    NEW_PERMISSION = "userGroups.newPermission",
    NEW_USER_GROUP = "userGroups.newUserGroup",
    PERMISSION_COLLECTION = "userGroups.permissionCollection",
    PERMISSION_LEVEL = "userGroups.permissionLevel",
    PERMISSION_WILL_BE_DELETED = "userGroups.permissionWillBeDeleted",
    PERMISSIONS = "userGroups.permissions",
    REMOVE_GROUP_MEMBERSHIP_QUESTION_MARK = "userGroups.removeGroupMembershipQuestionMark",
    REMOVE_MEMBER = "userGroups.removeMember",
    REMOVE_MEMBER_QUESTION_MARK = "userGroups.removeMemberQuestionMark",
    REMOVE_MEMBERSHIP = "userGroups.removeMembership",
    UPDATE_PERMISSION = "userGroups.updatePermission",
    USER_GROUPS = "userGroups.userGroups",
    USER_GROUP_NAME_ALREADY_EXISTS = "userGroups.userGroupNameAlreadyExists",
    USER_GROUP_WILL_BE_DELETED = "userGroups.userGroupWillBeDeleted",
}
